import React from 'react';
import useCheckPermissions from 'hooks/auth/useCheckPermission';
import { PERMISSIONS } from 'constants/auth';
import { Select, SelectOption } from 'components/ui';
import { EMAIL_TYPE_IDS } from 'constants/mail';

type SelectTemplateTypeProps = {
  enableRestriction: boolean,
  error: string,
  value: string,
  onChange: (v: string) => void,
  emailTypes: { id: number, type: string }[],
};

export default function SelectTemplateType(props: SelectTemplateTypeProps) {
  const { userCheckPermission } = useCheckPermissions();
  const userHasPermission = userCheckPermission(PERMISSIONS.TRANSACTIONAL_MAIL);
  return (
    <>
      <h6 className="mail-type-head"> Template Type </h6>
      <Select
        disabled={props.enableRestriction ? !userHasPermission : false}
        error={!!props.error}
        helperTxt={props.error}
        name="selectedTemplateTypeId"
        value={props.value}
        onChange={props.onChange}
      >
        <SelectOption disabled key="default" value={-1}>
          Select template type
        </SelectOption>
        {props.emailTypes.map(emailType => (
          <SelectOption
            disabled={
              emailType.id === EMAIL_TYPE_IDS.TRANSACTIONAL &&
              !userHasPermission
            }
            key={emailType.id}
            value={emailType.id}
          >
            {emailType.type}
          </SelectOption>
        ))}
      </Select>
    </>
  );
}
